import React, { useState } from "react";

import ItemTool from "./ItemTool";
import getItems from "fantastic/lib/items";

const ItemsToolsBlock = ({ creatorMode, adminMode }) => {
  const items = getItems();
  if (creatorMode) {
    items.push(
      {
        kind: "unsubscrible",
        contents: i18n.t('unsubscription_content'),
        label: i18n.t('unsubscription_label'),
        text_align: "center",
        css_background: "transparent",
        css_background_image: "none",
        css_background_repeat: "repeat",
        css_background_position: "center center",
        css_color: "",
        css_link_color: "",
        font_family: "",
        font_size: "",
        css_padding_top: "0",
        css_padding_bottom: "0",
        css_padding_left: "0",
        css_padding_right: "0"
      }
    );
  }

  return (
    <div className="fantastic-tools-block">
      <div className="fantastic-tools-block__header">
        <div className="fantastic-tools-block__caption">{ i18n.t('blocks') }</div>
      </div>
      <div className="fantastic-tools-block__body">
        {items.map((item, index) => (
          <ItemTool
            data={item}
            key={index}
            id={index}
            meta={{ type: "ITEM/NEW", kind: item.kind }}
            itemType="ITEM/NEW"
          />
        ))}
      </div>
    </div>
  );
};

export default ItemsToolsBlock;
